<template>
  <div>
    <!--  受注製品選択画面 -->
    <t-card>
      <div>
        <t-row class="marginBottom">
          <t-col>
            <!-- テーブル -->
            <div>
              <t-table
                ref="acceptProductsEditTableData"
                :data="acceptProductsEditTableData"
                class="table_common"
                header-cell-class-name="bg-default"
                :height="detailHeight"
                highlight-current-row
                :cell-class-name="tableCellClassName"
                border
                fit
              >
                <t-table-column type="selection" class-name="cell_txt_center" />

                <t-table-column
                  v-for="(column, index) in columns"
                  :key="index"
                  :type="column.type"
                  :prop="column.prop"
                  :label="column.label"
                  :min-width="column.width"
                  :align="column.align"
                  :header-align="column.headerAlign"
                  :class-name="column.class"
                  :show-overflow-tooltip="column.overflowTooltip"
                >
                  <!-- <template slot-scope="scope">
                    <t-checkbox
                      v-if="column.prop === 'ndOrderState'"
                      v-model="scope.row['ndOrderStateBool']"
                    ></t-checkbox>
                    <span v-else>
                      {{ scope.row[column.prop] }}
                    </span>
                  </template> -->
                </t-table-column>
              </t-table>
            </div>
          </t-col>
        </t-row>
      </div>

      <div :style="{ height: bottomHeight + 'px' }">
        <t-row class="marginBottom">
          <div>
            <t-col
              :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_TWENTY_ONE'))"
              >&nbsp;</t-col
            >

            <!-- 確定ボタン -->
            <t-col
              :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_THREE'))"
              align="right"
            >
              <t-button
                round
                type="warning"
                class="dialogButton_confirm_120_40"
                ref="confirmBtn"
                @click="confirmClick"
              >
                <i class="el-icon-check"></i>
                {{ $t("resource.COMMON_CONSTANT.CONFIRM") }}</t-button
              >
            </t-col>
          </div>
        </t-row>
      </div>
    </t-card>
  </div>
</template>
<script>
import { t } from "@/locales";
import { getAcceptProductFromNumber } from "@/services/acceptOrder";
import {
  formatStringToCurrency,
  getDialogContentHeight,
} from "@/utils/comFunction";
import { DIALOG_LINE_HEIGHT } from "@/utils/const";
//import { setColumnWidth } from "@/utils/table";
import { Message, Modal } from "@tellus/component";
export default {
  data() {
    return {
      //明細情報のheight
      detailHeight: getDialogContentHeight(
        window.innerHeight,
        0,
        DIALOG_LINE_HEIGHT * 1,
        20
      ),
      //合計情報のheight
      bottomHeight: DIALOG_LINE_HEIGHT * 1,

      //データ変更フラグ
      dataChangeFlg: false,

      //受注一覧選択情報
      acceptProductsEditTableData: [],

      //最大高さ
      maxheight: t(
        "widgetSize.ACCEPT_ORDER_INFO.DIALOG_ACCEPT_PRODUCT_EDIT_HEGHT"
      ),

      //受注可能製品のテーブルの列
      columns: [
        // {
        //   prop: "ndOrderState",
        //   label: t("resource.NUMBER.ACCEPT_ORDER_STATE"),
        //   width: t("widgetSize.tableCommon.defaultWidth"),
        //   class: "cell_txt_center",
        // },
        {
          prop: "ndProdName",
          label: t("resource.COMMON_CONSTANT.PRODUCT_NAME"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        {
          prop: "ndProdDrawNo",
          label: t("resource.COMMON_CONSTANT.PICTURE_NO"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        {
          prop: "ndProdQuantity",
          label: t("resource.ACCEPT_ORDER.NUMBER_COUNT"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_right",
        },
        {
          prop: "ndAcceptProdQuantity",
          label: t("resource.ACCEPT_ORDER.ACCEPT_COUNT"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_right",
        },
        {
          prop: "ndProdUnit",
          label: t("resource.COMMON_CONSTANT.UNIT"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_center",
          overflowTooltip: true,
        },
        {
          prop: "ndProdShape",
          label: t("resource.COMMON_CONSTANT.SHAPE"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_center",
          overflowTooltip: true,
        },
        {
          prop: "ndProdMaterial",
          label: t("resource.COMMON_CONSTANT.MATERIAL"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        {
          prop: "ndProdTreatment",
          label: t("resource.COMMON_CONSTANT.TREATMENT"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        {
          prop: "ndUSalesPrice",
          label: t("resource.ACCEPT_ORDER.SALES_U_PRICE"),
          width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_TWENTY"),
          class: "cell_txt_right",
        },
        {
          prop: "ndUSetPrice",
          label: t("resource.ACCEPT_ORDER.NUMBER_SET_U_PRICE"),
          width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_TWENTY"),
          class: "cell_txt_right",
          overflowTooltip: true,
        },
        {
          prop: "ndAcceptUSetPrice",
          label: t("resource.ACCEPT_ORDER.ACCEPT_SET_U_PRICE"),
          width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_TWENTY"),
          class: "cell_txt_right",
          overflowTooltip: true,
        },
        {
          prop: "ndTotSalesPrice",
          label: t("resource.NUMBER.TOT_SALES_PRICE"),
          width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_TWENTY"),
          class: "cell_txt_right",
        },
      ],
    };
  },

  props: {
    aobQuoteNo: {
      Type: Object,
    },
    editTableData: {
      Type: Object,
    },
    reacceptFlg: {
      Type: Object,
    },
  },
  mounted() {
    this.init();

    //列幅に自動調整
    //setColumnWidth(this.columns, this.acceptProductsEditTableData);

    //テーブルの高さを監視する
    window.addEventListener("resize", this.handleResize);
  },

  methods: {
    // ダイアログを閉じる
    close() {
      this.$emit("cancel");
    },

    //テーブルの高さを設定する
    handleResize() {
      this.detailHeight = getDialogContentHeight(
        window.innerHeight,
        0,
        DIALOG_LINE_HEIGHT * 1,
        20
      );
    },

    //确定ボタン
    confirmClick() {
      // フォーカス削除
      this.$refs.confirmBtn.$el.blur();
      //受注画面の製品
      // var paramProdNo = STR_EMPTY;

      // for (var i = 0; i < this.editTableData.length; i++) {
      //   paramProdNo = paramProdNo + this.editTableData[i].aodNdProdNo + "-";
      // }

      // //編集画面選択した製品
      // var selectedProdNo = STR_EMPTY;

      let acceptProductList = [];

      // //選択した製品の取得
      // for (var i = 0; i < this.acceptProductsEditTableData.length; i++) {
      //   var element = this.acceptProductsEditTableData[i];

      //   //受注状態がチェックする場合
      //   if (element.ndOrderStateBool) {
      //     acceptProductList.push({
      //       ndQuoteNo: element.ndQuoteNo,
      //       ndProdNo: element.ndProdNo,
      //     });

      //     selectedProdNo = selectedProdNo + element.ndProdNo + "-";
      //   }
      // }

      let data = this.$refs.acceptProductsEditTableData.selection;

      for (var i = 0; i < data.length; i++) {
        acceptProductList.push({
          ndQuoteNo: data[i].ndQuoteNo,
          ndProdNo: data[i].ndProdNo,
        });
      }

      if (!!data && data.length > 0) {
        let params = {
          reacceptFlg: this.reacceptFlg,
          acceptProductList: acceptProductList,
        };

        this.$emit("ok", params);
      } else {
        //製品が未選択場合
        Modal.showWarning("", t("message.COMMON_MESSAGE.PLEASE_SELECT_DATA"), {
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        });
      }
    },

    //データの変換処理
    dataProcess() {
      this.acceptProductsEditTableData.map((item) => {
        //受注数量
        item.ndAcceptProdQuantity = item.ndProdQuantity;
        //受注確定売価(個)
        item.ndAcceptUSetPrice = item.ndUSetPrice;

        for (var i = 0; i < this.editTableData.length; i++) {
          if (this.editTableData[i].aodNdProdNo === item.ndProdNo) {
            //受注状態をチェックする
            // item.ndOrderState = NB_ORDER_STATE_ORDERED;
            // item.ndOrderStateBool = true;

            this.$nextTick(() => {
              this.$refs.acceptProductsEditTableData.toggleRowSelection(
                item,
                true
              );
            });

            //受注数量
            item.ndAcceptProdQuantity = this.editTableData[i].aodProdQuantity;
            //受注確定売価(個)
            item.ndAcceptUSetPrice = this.editTableData[i].aodUSetPrice;
            break;
          }
        }

        //見積数量
        item.ndProdQuantity = formatStringToCurrency(item.ndProdQuantity);
        //受注数量
        item.ndAcceptProdQuantity = formatStringToCurrency(
          item.ndAcceptProdQuantity
        );

        //売価(JPY/个)
        item.ndUSalesPrice = formatStringToCurrency(item.ndUSalesPrice);

        //見積確定売価(個)
        item.ndUSetPrice = formatStringToCurrency(item.ndUSetPrice);
        //受注確定売価(個)
        item.ndAcceptUSetPrice = formatStringToCurrency(item.ndAcceptUSetPrice);

        //小計売上金額(JPY)
        item.ndTotSalesPrice = formatStringToCurrency(item.ndTotSalesPrice);

        return item;
      });
    },

    // 初期化
    init() {
      //検索処理
      let params = {
        aobQuoteNo: this.aobQuoteNo,
      };

      //採番情報から受注可能製品の取得
      getAcceptProductFromNumber(params)
        .then((res) => {
          var tmpTable;
          //受注状態をチェックしない
          tmpTable = res.acceptableProducts.map((item) => {
            item.ndOrderStateBool = false;
            return item;
          });
          this.acceptProductsEditTableData = tmpTable;

          this.dataProcess();

          //列幅に自動調整
          //setColumnWidth(this.columns, this.acceptProductsEditTableData);
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(
              t("message.COMMON_MESSAGE.DETAIL_SEARCH_FAILURE")
            );
          }
        })
        .finally(() => {});
    },

    //セルの配置
    tableCellClassName({ row, column, rowIndex, columnIndex }) {
      row.index = rowIndex;
      column.index = columnIndex;

      if (
        (row.ndProdQuantity != row.ndAcceptProdQuantity &&
          column.property == "ndAcceptProdQuantity") ||
        (row.ndUSetPrice != row.ndAcceptUSetPrice &&
          column.property == "ndAcceptUSetPrice")
      ) {
        this.dataChangeFlg = true;
        return "showColor";
      }
    },
  },
};
</script>
<style scoped>
::v-deep .el-table__row .showColor {
  color: red !important;
}
</style>
